import { getErrorMessage } from "@/shared/consts/error-codes"
import WarningSvg from '@/shared/assets/images/Warning.svg'

interface ErrorAlertProps {
    error: any
}

export const ErrorAlert = ({ error }: ErrorAlertProps) => (
    <div className="bg-red-100 mb-4 p-4 flex items-center text-red-500 border-b-2 rounded-lg border-red-500">
        <WarningSvg width={32} height={32} />
        <div className="text-color-dark ml-2">
            {getErrorMessage(error?.error_id)}
        </div>
    </div>
)

interface SuccessAlertProps {
    message: string
}

export const SuccessAlert = ({ message }: SuccessAlertProps) => (
    <div className="bg-green-100 mb-4 p-4 flex items-center text-green-500 border-b-2 rounded-lg border-green-500">
        <div className="text-color-dark">
            {message}
        </div>
    </div>
)

